import LazyChartControllerBase from './helpers/lazy_chart_controller_base';
import Chart from 'chart.js/auto';

export default class extends LazyChartControllerBase {
  static values = { inputs: String };
  static targets = ['chartcanvas'];

  _buildChart() {
    const chartData = JSON.parse(this.inputsValue);

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
      scales: {
        y: {
          ticks: {
            color: '#b2b3bd',
            count: 2,
            stepSize: 3600,
            crossAlign: 'center',
            callback: function (value, index) {
              if (index == 0) {
                return null;
              }
              const hours = Math.floor(value / 3600);
              return hours + 'h';
            },
          },
        },
        x: {
          ticks: {
            crossAlign: 'inner',
            color: '#b2b3bd',
            callback: function (value, index, values) {
              if (index === 0 || index === values.length - 1) {
                return this.getLabelForValue(value);
              } else {
                return null;
              }
            },
          },
        },
      },
    };

    new Chart(this.chartcanvasTarget, {
      type: 'line',
      data: chartData,
      options: chartOptions,
    });
  }
}
